import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { HttpService } from "./http.service";

const basePath = "/Holiday";
const request = HttpService.handleRequest();

export const HolidayService = {
  getAll,
  getList,
  insert,
  update,
  del,
  getById,
  remove,
  insertOrUpdate,
  getAllList,
  GetAllStateList
};

async function getAll() {
  return request.get(basePath);
}

async function getAllList() {
  return request.get(basePath+'/GetAllList');
}

async function insertOrUpdate(data) {
  return request.post(`${basePath}/create`, data);
}

async function insert(data) {
  return request.post(`${basePath}`, data);
}

async function update(data) {
  return request.put(basePath, data);
}

async function del(data) {
  return request.delete(basePath, { data });
}

async function remove(data) {
  return request.post(`${basePath}/remove`, data);
}

async function getById(id) {
  return request.get(`${basePath}/${id}`);
}

async function getList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

async function GetAllStateList() {
  return request.get(basePath+'/GetAllStateList');
}



export default HolidayService;